// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"458":"1398e677","605":"737c37d6","721":"85b7f038","775":"85b7f038"}[chunkId] + ".chunk.css";
};